export default "__VITE_ASSET__DHYDheGZ__"